export const API_BASE_URL = process.env.REACT_APP_API_URL;

export const TIPOS_INSTITUICAO = ['Universidade', 'Faculdade', 'Instituto', 'Escola Técnica'];

export const STATUS_PRE_INSCRICAO = ['Pendente', 'Aprovada', 'Rejeitada'];

export const TIPOS_USUARIO = ['Admin', 'Instituicao', 'Estudante'];

export const LIMITE_PAGINACAO = 10;

export const FORMATOS_DATA = {
  PADRAO: 'dd/MM/yyyy',
  COM_HORA: 'dd/MM/yyyy HH:mm',
  ISO: 'yyyy-MM-dd'
};

export const CORES = {
  PRIMARIA: '#1976d2',
  SECUNDARIA: '#dc004e',
  SUCESSO: '#4caf50',
  ERRO: '#f44336',
  AVISO: '#ff9800'
};

export const ROTAS = {
  LOGIN: '/login',
  REGISTRO: '/registro',
  DASHBOARD: '/dashboard',
  INSTITUICOES: '/instituicoes',
  ESTUDANTES: '/estudantes',
  CAMPANHAS: '/campanhas',
  PRE_INSCRICOES: '/pre-inscricoes',
  RELATORIOS: '/relatorios'
};
